export function randomBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateOrderId(prefix: string = "OM"): string {
  const randomId = randomBetween(100000, 999999);
  return `${prefix}-${randomId}`;
}
